import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import gql from 'graphql-tag';
import { useApolloClient } from '@apollo/client';
import { useI18n } from '~Hooks';

const Wrapper = styled.div`
  border-left: 6px solid rgb(0, 107, 74);
`;

const Title = styled.div`
  color: rgb(1, 46, 35);
  font-family: RobotoMono-Medium;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0.12px;
  line-height: 28px;
  text-transform: uppercase;
  padding: 20px 0;
  margin: 0 32px 0 26px;
  border-bottom: 1px solid rgb(224, 224, 227);
`;

interface Props {
  offerId: string;
}
const OfferItemWrapper: React.FunctionComponent<Props> = ({ offerId, children }) => {
  const client = useApolloClient();
  const { i18n } = useI18n();
  const offer = useMemo(() => {
    return client.readFragment({
      id: offerId,
      fragment: gql`
        fragment offerKiosk on Offer {
          id
          nameLang {
            id
            se
            en
            es
            no
          }
        }
      `,
    });
  }, [offerId]);

  return (
    <Wrapper>
      <Title>{i18n(offer.nameLang)}</Title> {children}
    </Wrapper>
  );
};

export default OfferItemWrapper;
